import { useRef, useMemo, useEffect } from 'react';

import {
  VARIANTS,
  DEFAULT_HEIGHT,
  SIMPLE_DEFAULT_OPTIONS,
  CONDENSED_DEFAULT_OPTIONS,
  FULL_DEFAULT_OPTIONS,
} from './constants';

export const useVariantOptions = variant => {
  if (variant === VARIANTS.SIMPLE) {
    return SIMPLE_DEFAULT_OPTIONS;
  }

  if (variant === VARIANTS.CONDENSED) {
    return CONDENSED_DEFAULT_OPTIONS;
  }

  return FULL_DEFAULT_OPTIONS;
};

export const useRedactorOptions = ({
  variant,
  disabled,
  onChange,
  minHeight,
  placeholder,
} = {}) => {
  const options = useVariantOptions(variant);

  return useMemo(
    () => ({
      ...options,
      placeholder,
      minHeight: minHeight || options.minHeight || DEFAULT_HEIGHT,
      regexps: {
        ...$R.opts.regex,
        linkimage: /$a/,
        linkvimeo: /$a/,
        linkyoutube: /$a/,
      },
      callbacks: {
        keydown: e => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        changed(text) {
          const body = typeof text !== 'undefined' ? text : this.code.get();
          if (typeof onChange === 'function') {
            onChange(body);
          }
        },
      },
    }),
    [options, disabled, onChange, minHeight, placeholder],
  );
};

const useRedactor = (ref, props = {}) => {
  const variantOptions = useRedactorOptions(props || {});
  const redactorAppRef = useRef();

  useEffect(() => {
    const anchorElement = ref.current;
    redactorAppRef.current = $R(anchorElement, variantOptions);
    return () => $R(anchorElement, 'destroy');
  }, [ref, variantOptions]);

  return redactorAppRef.current;
};

export default useRedactor;
